import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslatePipe } from '../../../../core/pipes/translate.pipe';
import { TranslationService } from '../../../../core/services/translation.service';
import { LanguageService } from '../../../../core/services/language.service';
import { Subscription } from 'rxjs';
import {
  UserCategoryCardComponent,
  UserCategory,
} from '../../../../shared/components/user-category-card/user-category-card';

@Component({
  selector: 'app-home-who-are-you',
  imports: [CommonModule, UserCategoryCardComponent, TranslatePipe],
  templateUrl: './home-who-are-you.html',
  styleUrl: './home-who-are-you.scss',
})
export class HomeWhoAreYou implements OnInit, OnDestroy {
  userCategories: UserCategory[] = [];
  private subscriptions: Subscription[] = [];

  constructor(
    private translationService: TranslationService,
    private languageService: LanguageService,
  ) {}

  ngOnInit(): void {
    // Wait for translations to load
    const translationSub = this.translationService.translationsLoaded$.subscribe((loaded) => {
      if (loaded) {
        this.loadCategories();
      }
    });
    this.subscriptions.push(translationSub);

    // Subscribe to language changes to reload categories
    const langSub = this.languageService.currentLanguage$.subscribe(() => {
      if (this.translationService.isLoaded()) {
        this.loadCategories();
      }
    });
    this.subscriptions.push(langSub);
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
  }

  private loadCategories(): void {
    const t = this.translationService;

    this.userCategories = [
      {
        theme: 'blue',
        icon: 'fas fa-search',
        title: t.t('home.whoAreYou.categories.seekers.title'),
        description: t.t('home.whoAreYou.categories.seekers.description'),
        features: [
          t.t('home.whoAreYou.categories.seekers.features.search'),
          t.t('home.whoAreYou.categories.seekers.features.favorites'),
          t.t('home.whoAreYou.categories.seekers.features.viewings'),
          t.t('home.whoAreYou.categories.seekers.features.booking'),
          t.t('home.whoAreYou.categories.seekers.features.alerts'),
          t.t('home.whoAreYou.categories.seekers.features.compare'),
        ],
        buttonText: t.t('home.whoAreYou.categories.seekers.button'),
      },
      {
        theme: 'green',
        icon: 'fas fa-home',
        title: t.t('home.whoAreYou.categories.owners.title'),
        description: t.t('home.whoAreYou.categories.owners.description'),
        features: [
          t.t('home.whoAreYou.categories.owners.features.listings'),
          t.t('home.whoAreYou.categories.owners.features.analysis'),
          t.t('home.whoAreYou.categories.owners.features.management'),
          t.t('home.whoAreYou.categories.owners.features.pricing'),
          t.t('home.whoAreYou.categories.owners.features.aiDescription'),
          t.t('home.whoAreYou.categories.owners.features.reports'),
        ],
        buttonText: t.t('home.whoAreYou.categories.owners.button'),
        buttonIcon: 'fas fa-arrow-right',
        userType: 'owner',
      },
      {
        theme: 'purple',
        icon: 'fas fa-briefcase',
        title: t.t('home.whoAreYou.categories.brokers.title'),
        description: t.t('home.whoAreYou.categories.brokers.description'),
        features: [
          t.t('home.whoAreYou.categories.brokers.features.crm'),
          t.t('home.whoAreYou.categories.brokers.features.management'),
          t.t('home.whoAreYou.categories.brokers.features.classification'),
          t.t('home.whoAreYou.categories.brokers.features.tracking'),
          t.t('home.whoAreYou.categories.brokers.features.analysis'),
          t.t('home.whoAreYou.categories.brokers.features.reports'),
        ],
        buttonText: t.t('home.whoAreYou.categories.brokers.button'),
        buttonIcon: 'fas fa-arrow-right',
        userType: 'broker',
      },
      {
        theme: 'orange',
        icon: 'fas fa-building',
        title: t.t('home.whoAreYou.categories.developers.title'),
        description: t.t('home.whoAreYou.categories.developers.description'),
        features: [
          t.t('home.whoAreYou.categories.developers.features.projects'),
          t.t('home.whoAreYou.categories.developers.features.management'),
          t.t('home.whoAreYou.categories.developers.features.analysis'),
          t.t('home.whoAreYou.categories.developers.features.tracking'),
          t.t('home.whoAreYou.categories.developers.features.dashboard'),
          t.t('home.whoAreYou.categories.developers.features.team'),
        ],
        buttonText: t.t('home.whoAreYou.categories.developers.button'),
        buttonIcon: 'fas fa-arrow-right',
        userType: 'developer',
      },
    ];
  }
}
